<template>
  <div name="hres8ax" class="row personal-wrapper">
    <component-staappr  :staappr='staappr'
                        :nowLang="app.nowLang"
                        :detailIndexY="detailIndex.dteempdb_y"
                        :detailIndexM="detailIndex.dteempdb_m"
                        :currentCodempid="codempid"
                        :currentDescCodempid="descCodempid"
                        :currentDteyrepay="currentDteyrepay"
                        @setCurrentDteyrepay="currentDteyrepay = arguments[0]" />

    <div class="col-md-12 menu border-bottom-color-skin-dark-10" v-show="!indexDisp">
      <div class="panelbutton-mb" :class="{ 'hidden' : pcDisp }">
        <div class="pers-header-btn">
          <div class="icon-menu fa fa-bars color-skin"></div>
          <div class="label-btn-pers color-skin" @click="toggleMenuMobile()"> Tax Menu </div>
        </div>

      </div>

      <div class="cal-panelbutton">
        <div class="rows clearfix">
          <div class=" box-btn-cal hover btn-width clearfix" :class="{ 'active color-skin' : totalIncomeYearActive }" @click.stop="toggleAndSave(1, currentPage)">
            <div class="label-btn-cal">

              <img class="menu-icon" src="../../assets/img/cal-tax/icon-menu1.png">
              <div :class="{ 'hidden' : pcDisp }">{{labels[app.nowLang]['HRES8AXC1']['90']}}</div>
              <div :class="{ 'hidden' : !pcDisp }">{{labels[app.nowLang]['HRES8AXC1']['20']}}</div>
            </div>

          </div>

          <div class=" box-btn-cal hover btn-width clearfix" :class="{ 'active color-skin' : reduceDunationActive }" @click.stop="toggleAndSave(2, currentPage)">
            <div class="label-btn-cal">
              <img class="menu-icon" src="../../assets/img/cal-tax/icon-menu2.png">
              <div :class="{ 'hidden' : pcDisp }">{{labels[app.nowLang]['HRES8AXC2']['80']}}</div>
              <div :class="{ 'hidden' : !pcDisp }">{{labels[app.nowLang]['HRES8AXC2']['10']}}</div>
            </div>
          </div>
          <div class=" box-btn-cal hover btn-width clearfix"  :class="{ 'active color-skin' : investmentPlanActive }" @click.stop="toggleAndSave(3, currentPage)">
            <div class="label-btn-cal">
              <img class="menu-icon" src="../../assets/img/cal-tax/icon-menu3.png">
              <div :class="{ 'hidden' : pcDisp }">{{labels[app.nowLang]['HRES8AXC3']['120']}}</div>
              <div :class="{ 'hidden' : !pcDisp }">{{labels[app.nowLang]['HRES8AXC3']['10']}}</div>
            </div>
          </div>
          <div class=" box-btn-cal hover btn-width clearfix" :class="{ 'active color-skin' : taxSummaryYearActive }" @click.stop="toggleAndSave(4, currentPage)">
            <div class="label-btn-cal">
              <img class="menu-icon" src="../../assets/img/cal-tax/icon-menu4.png">
              <div :class="{ 'hidden' : pcDisp }">{{labels[app.nowLang]['HRES8AXC4']['70']}}</div>
              <div :class="{ 'hidden' : !pcDisp }">{{labels[app.nowLang]['HRES8AXC4']['10']}}</div>
            </div>
          </div>
<!--           <div class=" box-btn-cal arrow-width" @click.stop="onArrowRight()">
            <i class="label-btn-cal fa fa-angle-right" aria-hidden="true" ></i>
          </div> -->
        </div>
      </div>
    </div>
    <div class="col-md-12 clear-padding" v-show="(!menuMbDisp) && !indexDisp">

      <v-touch @swipeleft="onSwipeLeft" @swiperight="onSwipeRight">

        <hres8ax-salary class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
                        v-show="totalIncomeYearActive"
                        :labels="labels[app.nowLang]"
                        :detailSalary="detailSalary"/>
     
        <hres8ax-deduction class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
                          v-show="reduceDunationActive"
                          :detailEvent="detailEvent"
                          :detailDeductionTable1="columns[app.nowLang].detailDeductionTable1"
                          :detailDeductionTable2="columns[app.nowLang].detailDeductionTable2"
                          :labels="labels[app.nowLang]"
                          :detailDeduction="detailDeduction"/>

        <hres8ax-invest class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
                        v-show="investmentPlanActive"
                        :labels="labels[app.nowLang]"       
                        :detailInvest="detailInvest" />
          
        <hres8ax-caltax class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
                        v-show="taxSummaryYearActive"
                        :labels="labels[app.nowLang]"
                        :detailCaltax="detailCaltax" />
      </v-touch>
    </div>
    <input data-toggle="modal" data-target="#hres8ax-popup-detail-deduction" ref="popupDetailDeduction" type="hidden"/>

    <popup-detail-deduction :labels="labels[app.nowLang]"
                           :nowLang="app.nowLang"
                           :data="popupDetailDeduction"
                           :detailDeductionSelected="detailDeductionSelected" />

  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres8ax/mutation-types'
import moment from 'moment'
import hres8axSalary from 'components/hres8ax/salary'
import hres8axDeduction from 'components/hres8ax/deduction'
import hres8axInvest from 'components/hres8ax/invest'
import hres8axCaltax from 'components/hres8ax/caltax'
import componentStaappr from 'components/hres8ax/componentStaappr'
import popupDetailDeduction from 'components/hres8ax/popupDetailDeduction'

export default {
  name: 'hres8ax',
  data () {
    return {
      app: this.$parent.$parent.$parent,
      swipeRight: false,
      swipeLeft: false,
      totalIncomeYearActive: true,
      reduceDunationActive: false,
      investmentPlanActive: false,
      taxSummaryYearActive: false,
      menuMbDisp: false,
      subTopic: true,
      page: 1,
      subPage: 1,
      indexDisp: false,
      currentEmpdby: '',
      currentDteyrepay: moment().format('YYYY'),
      currentPage: 1
    }
  },
  created () {
    this.receivedHres8axColumnsLabels()
    this.receivedHres8axDetailIndex({ codempid: this.codempid })
    this.receivedHres8axDetailSalary({ dteyrepay: this.currentDteyrepay })
  },
  watch: {
    currentDteyrepay () {
      switch (this.page) {
        case 1:
          this.receivedHres8axDetailSalary({ dteyrepay: this.currentDteyrepay })
          break
        case 2:
          this.receivedHres8axDetailDeduction({ dteyrepay: this.currentDteyrepay })
          break
        case 3:
          this.receivedHres8axDetailInvest({ dteyrepay: this.currentDteyrepay })
          break
        case 4:
          this.receivedHres8axDetailCaltax({ dteyrepay: this.currentDteyrepay })
          break
        default:
          break
      }
    }
  },
  computed: {
    pcDisp () {
      return this.app.pcDisp
    },
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    },
    currentUser () {
      return this.app.currentUser
    },
    descCodempid () {
      return this.app.currentUser.username[this.app.nowLang]
    },
    ...mapGetters({
      columns: types.GET_HRES8AX_COLUMNS,
      labels: types.GET_HRES8AX_LABELS,
      index: types.GET_HRES8AX_INDEX,
      detailDeductionSelected: types.GET_HRES8AX_DETAIL_DEDUCTION_SELECTED,
      detailIndex: types.GET_HRES8AX_DETAIL_INDEX,
      detailSalary: types.GET_HRES8AX_DETAIL_SALARY,
      detailDeduction: types.GET_HRES8AX_DETAIL_DEDUCTION,
      detailInvest: types.GET_HRES8AX_DETAIL_INVEST,
      detailCaltax: types.GET_HRES8AX_DETAIL_CALTAX,
      popupDetailDeduction: types.GET_HRES8AX_DETAIL_DEDUCTION_POPUP
    })
  },
  methods: {
    detailEvent (param, dataRows) {
      let popupParams = {
        p_coddeduct: param.coddeduct
      }
      this.setDetailDeductionSelected(param)
      this.receivedHres8axDetailDeductionPopup(popupParams)
      this.$refs.popupDetailDeduction.click()
    },
    onArrowLeft () {
      this.swipeRight = false
      this.swipeLeft = false
      if (!this.pcDisp) {
        this.swipeLeft = true
      }
      this.triggerArrowButton(-1)
    },
    onArrowRight () {
      this.swipeRight = false
      this.swipeLeft = false
      if (!this.pcDisp) {
        this.swipeRight = true
      }
      this.triggerArrowButton(1)
    },
    onSwipeRight () {
      if (!this.pcDisp) {
        this.swipeRight = false
        this.swipeLeft = false
        if (!this.pcDisp) {
          this.swipeRight = true
        }
        this.triggerSwipeButton(-1)
      }
    },
    onSwipeLeft () {
      if (!this.pcDisp) {
        this.swipeRight = false
        this.swipeLeft = false
        if (!this.pcDisp) {
          this.swipeLeft = true
        }
        this.triggerSwipeButton(1)
      }
    },
    triggerArrowButton (amountPage) {
      this.page = this.page + amountPage
      if (this.page <= 0) {
        this.page = 4
      }
      if (this.page > 4) {
        this.page = 1
      }
      if (this.page === 2) {
        this.subPage = 1
      }
      this.toggleAndSave(this.page, this.currentPage)
    },
    triggerSwipeButton (amountPage) {
      if (this.page !== 2 || this.subPage + amountPage <= 0 || this.subPage + amountPage > 5) {
        this.page = this.page + amountPage
        if (this.page === 2 && amountPage > 0) {
          this.subPage = 1
        }
        if (this.page === 2 && amountPage < 0) {
          this.subPage = 4
        }
      } else {
        this.subPage = this.subPage + amountPage
      }
      if (this.page <= 0) {
        this.page = 4
      }
      if (this.page > 4) {
        this.page = 1
      }
      if (this.subPage > 4) {
        this.subPage = 1
      }
      if (this.subPage <= 0) {
        this.subPage = 4
      }
      this.toggleAndSave(this.page, this.currentPage)
    },
    toggleAndSave (page, currentPage) {
      if (page !== currentPage) {
        this.savePage(page, currentPage)
        this.togglePage(page)
        this.currentPage = page
      }
    },
    savePage (page, currentPage) {
      let detailParams = {
        codempid: this.codempid,
        dteyrepay: this.currentDteyrepay
      }
      switch (currentPage) {
        case 1:
          this.saveHres8axDetailSalary({ detailParams: detailParams, detailSalary: this.detailSalary, targetPage: page })
          break
        case 2:
          this.saveHres8axDetailDeduction({ detailParams: detailParams, detailDeduction: this.detailDeduction, targetPage: page })
          break
        case 3:
          this.saveHres8axDetailInvest({ detailParams: detailParams, detailInvest: this.detailInvest, targetPage: page })
          break
        case 4:
          break
        default:
          break
      }
    },
    togglePage (page) {
      this.page = page
      this.indexDisp = false
      this.totalIncomeYearActive = false
      this.reduceDunationActive = false
      this.investmentPlanActive = false
      this.taxSummaryYearActive = false
      this.menuMbDisp = false
      switch (page) {
        case 0:
          this.indexDisp = true
          break
        case 1:
          this.totalIncomeYearActive = true
          this.headerInfo = true
          this.receivedHres8axDetailSalary({ dteyrepay: this.currentDteyrepay })
          break
        case 2:
          this.reduceDunationActive = true
          this.receivedHres8axDetailDeduction({ dteyrepay: this.currentDteyrepay })
          break
        case 3:
          this.investmentPlanActive = true
          this.receivedHres8axDetailInvest({ dteyrepay: this.currentDteyrepay })
          break
        case 4:
          this.taxSummaryYearActive = true
          break
        default:
          this.totalIncomeYearActive = true
          break
      }
    },
    toggleMenuMobile () {
      this.swipeLeft = false
      this.swipeRight = false
      this.menuMbDisp = !this.menuMbDisp
    },
    ...mapMutations({
      setDetailDeductionSelected: types.SET_HRES8AX_DETAIL_DEDUCTION_SELECTED
    }),
    ...mapActions({
      receivedHres8axColumnsLabels: types.RECEIVED_HRES8AX_COLUMNS_LABELS,
      receivedHres8axDetailIndex: types.RECEIVED_HRES8AX_DETAIL_INDEX,
      receivedHres8axDetailSalary: types.RECEIVED_HRES8AX_DETAIL_SALARY,
      receivedHres8axDetailDeduction: types.RECEIVED_HRES8AX_DETAIL_DEDUCTION,
      receivedHres8axDetailInvest: types.RECEIVED_HRES8AX_DETAIL_INVEST,
      receivedHres8axDetailCaltax: types.RECEIVED_HRES8AX_DETAIL_CALTAX,
      receivedHres8axDetailDeductionPopup: types.RECEIVED_HRES8AX_DETAIL_DEDUCTION_POPUP,
      saveHres8axDetailSalary: types.SAVE_HRES8AX_SALARY_SAVE,
      saveHres8axDetailDeduction: types.SAVE_HRES8AX_DEDUCTION_SAVE,
      saveHres8axDetailInvest: types.SAVE_HRES8AX_INVEST_SAVE
    })
  },
  components: {
    hres8axSalary,
    hres8axDeduction,
    hres8axInvest,
    hres8axCaltax,
    componentStaappr,
    popupDetailDeduction
  }
}
</script>

<style src="./style.scss" lang='scss'></style>


// WEBPACK FOOTER //
// component.vue?2c46d401